import React, { useRef, useEffect } from "react";

function PickFixtureConfirmPopup({ message, onConfirm, onCancel }) {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onCancel(); // Close the popup on outside click only
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onCancel]);

  return (
    <div className="fixed inset-0 z-50 bg-black/20 flex items-center justify-center p-4">
      <div
        ref={popupRef}
        className="relative bg-white rounded-lg shadow-xl p-6 w-full max-w-sm text-center space-y-6"
      >
        <button
          onClick={onCancel}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
        >
          &times;
        </button>

        <p className="text-lg font-semibold text-gray-800">{message}</p>

        <div className="flex justify-center gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg"
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-green-600 text-white rounded-lg"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}

export default PickFixtureConfirmPopup;
